/* eslint no-shadow: ["error", { "allow": ["state", "getters"] }] */

import findIndex from 'lodash/findIndex'
import keyBy from 'lodash/keyBy'
import reject from 'lodash/reject'
import Vue from 'vue'

import { FETCH_LOCALES } from '../../actions.type'
import {
  CREATE_LOCALE,
  REMOVE_LOCALE,
  SET_LOCALE_ALL_REQUEST,
  SET_LOCALE_ALL_VALUE,
  UPDATE_LOCALE
} from '../../mutations.type'

const state = {
  all: {
    request: {
      isLoading: undefined,
      isSuccess: undefined,
      isError: undefined,
      isFatalError: undefined,
      delay: undefined,
      lastRequestTime: undefined
    },
    value: []
  }
}

const getters = {
  localeAllValue: (state) => state.all.value,
  localeAllRequest: (state) => state.all.request,
  localeAllById: (state) => keyBy(state.all.value, 'id')
}

const actions = {
  async [FETCH_LOCALES]({ commit, state }, params) {
    if (
      (state.all.request.isSuccess && !params?.isReload) ||
      state.all.request.isLoading ||
      state.all.request.isError
    ) {
      return
    }
    try {
      const { data } = await Vue.axios.get('locale', {
        'axios-retry': {
          beforeTry: () => {
            commit(SET_LOCALE_ALL_REQUEST, {
              isLoading: true,
              isError: false
            })
          },
          afterTry: ({ delay, lastRequestTime }) => {
            commit(SET_LOCALE_ALL_REQUEST, {
              isLoading: false,
              isError: true,
              delay,
              lastRequestTime
            })
          }
        }
      })
      commit(SET_LOCALE_ALL_REQUEST, {
        isLoading: false,
        isSuccess: true
      })
      commit(SET_LOCALE_ALL_VALUE, data)
    } catch (e) {
      commit(SET_LOCALE_ALL_REQUEST, {
        isFatalError: true,
        isLoading: false
      })
    }
  },

  async SOCKET_CREATE_LOCALE({ commit }, value) {
    commit(CREATE_LOCALE, value)
  },

  async SOCKET_UPDATE_LOCALE({ commit }, value) {
    commit(UPDATE_LOCALE, value)
  },

  async SOCKET_REMOVE_LOCALE({ commit }, id) {
    commit(REMOVE_LOCALE, id)
  }
}

const mutations = {
  [SET_LOCALE_ALL_REQUEST](state, request) {
    state.all.request = {
      ...state.all.request,
      ...request
    }
  },
  [SET_LOCALE_ALL_VALUE](state, locales) {
    state.all.value = locales
  },
  [UPDATE_LOCALE](state, updatedLocale) {
    state.all.value.splice(
      findIndex(state.all.value, { id: updatedLocale.id }),
      1,
      updatedLocale
    )
  },
  [CREATE_LOCALE](state, createdLocale) {
    state.all.value.push(createdLocale)
  },
  [REMOVE_LOCALE](state, id) {
    state.all.value = reject(state.all.value, { id })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
